import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin, Observable } from 'rxjs';
import { ContribuyentesService, CreditosService, RolesService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';
import { ListasService } from '../../../services/listas/listas.service';
import { ReportesService } from '../../../services/reportes/reportes.service';
import { AwsService } from '../../../services/awsser/aws.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import * as fs from 'file-saver';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { start } from 'repl';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-mesa-control',
  templateUrl: './mesa-control.component.html',
  styleUrls: ['./mesa-control.component.scss']
})
export class MesaControlComponent implements OnInit {

  
  uploadForm: FormGroup;
  url: any;
  file: any;
  calificacionBC:any;
  facturas: any[] = [];
  fileName = 'Layout.xlsx';
  datosdetalles: any[] = [];
  cargado = false;
  anuality_date = [];
  selectedSol: any[] = [];
  solicitudes: any[] = [];
  estatus: any[] = [];
  usuarios: any[] = [];
  idu: string;
  documentonulo: boolean;
  uploadURL: Observable<string>;
  uploadProgress: Observable<number>;
  showModal: boolean;
  showmodalds: boolean;
  idsolicitud: string;
  foliosolicitud: string;
  carpeta: string;
  nombrearchivosubido: string;
  estatus1: string;
  estatusburo: string;
  estatusindice: string;
  estatuspayment: string;
  estatusflow: string;
  car_creditnum = 0;
  mortagage_loannum = 0;

  filtro = 'SO';
  resumen_creditos = [];
  creditos_buro = [];
  calificaciones = [];
  requests = [];
  terms = [];
  paymentPeriods = [];
  intereses = 16;
  colDetallesCustomer = [];
  idRechazo = '';
  ngSelect = '';

  creditos = [];
  rates = [];
  ivaRates = [];
  payments = [];
  documents = [];
  regimen_fiscal_contribuyente = [];
  client_status = [];
  datosEmpleado = {};
  credit_status = [];
  credit_status1: any;
  buroStatus = false;
  analysisStatus = false;
  ingresos_netos: any;
  ingresos_netosnum = 0;
  egresos_netos: any;
  egresos_netosnum = 0;
  gastos_familiares: any;
  gastos_familiaresnum = 0;
  renta_casa: any;
  renta_casanum = 0;
  creditos_CPnum = 0;
  creditos_LPnum = 0;
  creditos_CP: any;
  creditos_LP: any;
  periodo_pago: any;
  analysis: any;
  accured_liabilities: any;
  debt_horizon: any;
  anual_rate: any;
  balance_due: any;
  car_credit: any;
  cash_flow: any;
  created_at: any;
  analisis_credit_status: any;
  credit_type: any;
  customer_credit_id: any;
  customer_number: any;
  debt: any;
  debtnum = 0;
  debt_rate: any;
  departamental_credit: any;
  discounts: any;
  id: any;
  last_key: any;
  lowest_key = '';
  mop_key: any;
  mortagage_loan: any;
  net_flow: any;
  net_flownum = 0;
  other_credits: any;
  overall_rate: any;
  payment_capacity: any;
  previus_credit: any;
  report_date: any;
  total_amount: any;
  total_cost: any;
  total_debt: any;
  buro: any;
  fechaReporte: any;
  pdf: any;
  urlburo: string;
  rfcBC: any;
  saldosVencidos: any;
  creditoSeleccionadoTabla = {};
  maritalStatus: any;
  lists = [];
  regimen_fiscal = [];
  cols = [

      { field: 'credit_folio', header: 'Folio', moneda: false },
      { field: 'credit_number', header: 'Número de Crédito', moneda: false },
      { field: 'siac_id', header: 'ID SIAC', moneda: false },
      { field: 'cat2', header: 'CAT', moneda: false },
      { field: 'compañia', header: 'Compañía', moneda: false },
      { field: 'fecha_solicitud', header: 'Fecha solicitud', moneda: false },
      { field: 'fecha_inicio', header: 'Fecha inicio', moneda: false },
      { field: 'empleado', header: 'Nombre Empleado', moneda: false },
      { field: 'adeudo_total', header: 'Adeudo Total', moneda: true },
      { field: 'pedido_total', header: 'Total Solicitado', moneda: true },
      { field: 'rate', header: 'Tasa', moneda: false },
      { field: 'comision', header: 'Comision', moneda: true },
      { field: 'seguro', header: 'Seguro', moneda: true },
      { field: 'destino', header: 'Destino', moneda: false },
      { field: 'plazo_value', header: 'Plazo', moneda: false },
      { field: 'pago_fijo', header: 'Pago Fijo', moneda: true },
      { field: 'estatus', header: 'Estado', moneda: false },
      { field: 'nombre_analista', header: 'Analista', moneda: false },
      { field: 'refinancing_status', header: 'Refinanciamiento', moneda: false },
      { field: 'refinancing_reviewer', header: 'Revisado por', moneda: false },
      { field: 'name', header: 'Usuario asignado', moneda: false },
    ];
  colsVisibles = [];
  mostrarTodas = false;
  mesaControl = false;
  admin = false;
  defaultStatus = 'AC';
  credit: any;
  lastStatus = '';
  tesoreria = false;
  refinanciamientoItems = [];
  cartasRevisadas: Set<string> = new Set();
  companies = [];
  
  constructor(
    private creditosService: CreditosService,
    private formBuilder: FormBuilder, private httpClient: HttpClient, 
    private listasService: ListasService,
    private reportesService: ReportesService,
    private awsService: AwsService,
    private sanitizer: DomSanitizer,
    private rolesService: RolesService,
    private zone: NgZone,
    private contribuyenteService: ContribuyentesService
    ) {}
    
    ngOnInit() {

      this.awsService.getCompanyes().subscribe(resp => {
        this.companies = resp;
      })
      this.rolesService.getRoles().subscribe(resp => {
        var rol = resp.find(r => r.id == localStorage.getItem('rid'));
        if(rol.name.toLowerCase().includes('control')){
          this.mesaControl = true;
          this.admin = false;
        } else if(rol.name.toLowerCase().includes('admin')){
          this.mesaControl = false;
          this.admin = true;
        } else if(rol.name.toLowerCase().includes('tesoreria') || rol.name.toLowerCase().includes('tesorería')){
          this.tesoreria = true; 
          this.defaultStatus = 'VA';
        }
      })

    //variables e inicializaciones sin fecha solicitud, adeudo total, destino, pago fijo
    this.colsVisibles = this.cols.filter(col =>
      ['credit_folio', 'credit_number', 'siac_id', 'cat2', 'compañia',
        'fecha_inicio', 'fecha_solicitud', 'destino', 'empleado', 'pedido_total',
        'rate', 'comision', 'seguro','plazo_value', 'estatus', 'nombre_analista', 'refinancing_status', 'refinancing_reviewer',
        'usuario', 'name'].includes(col.field)
    );
    this.creditos = [];
    this.usuarios = [];
    this.estatus = [];
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    //const estatus: any = document.getElementById('estatus');
    this.selectedSol = [];
    this.idu = localStorage.getItem('uid');

    //llamadas a servicios
    forkJoin({
      financialWorkers: this.reportesService.financialWorkers(),
      extRates: this.creditosService.ext_rates(),
      lists: this.listasService.getLists(),
      condiciones: this.creditosService.getCondiciones(),
      periodosPagos: this.creditosService.getperiodosPagos(),
      
    }).subscribe((resp: any) => {
      //financial workers
      Object.keys(resp.financialWorkers).forEach(key => { this.usuarios.push(resp.financialWorkers[key]); });
      //ext rates
      resp.extRates['data'].forEach(rate => {
        if(rate.attributes.rate_type === 'TA'){
          this.rates.push(rate.attributes);
        }else if(rate.attributes.rate_type === 'IVA'){
          this.ivaRates.push(rate.attributes);
        }
      });
      //listas
      resp.lists['data'].forEach(list => {
        if(list['attributes'].domain === 'FLOW_STATUS'){
          this.estatus.push(list['attributes']);
        }
      });
      resp.lists['data'].forEach(list => {this.lists.push(list.attributes);});
      this.maritalStatus = this.lists.filter(p => p.domain === 'PERSON_MARTIAL_STATUS');
      this.regimen_fiscal = this.lists.filter(p => p.domain === 'CONTRIBUTOR_FISCAL_REGIME');
      //condiciones
      this.terms = resp.condiciones;
      this.paymentPeriods = [...resp.periodosPagos, { id: '0', key: 'Pago Fijo' }];
      //creditos
      this.consultaCreditos();
      this.cargado = true;
      swal2.close();
      
    }, error => {
    console.error(error);
    swal2.close();
    swal2.fire('Error', 'Ocurrió un error al cargar los datos.', 'error');
  })
  }

    toggleColumns() {
    this.mostrarTodas = !this.mostrarTodas;//fecha solicitud, adeudo total, destino, pago fijo
    if (this.mostrarTodas) {
      this.colsVisibles = this.cols;
    } else {
      this.colsVisibles = this.cols.filter(col =>
        ['credit_folio', 'credit_number', 'cat2', 'compañia',
        'fecha_inicio', 'nombre', 'pedido_total',
        'rate', 'comision', 'seguro','plazo_value', 'estatus', 'nombre_analista', 'refinancing_status', 'refinancing_reviewer',
        'usuario'].includes(col.field)
      );
    }
  }

  consultaCreditos(){
    this.creditosService.customer_credits_by_status(this.idu, this.defaultStatus).subscribe(resp => {
      this.creditos = JSON.parse(JSON.stringify(resp));
      this.lastStatus = this.defaultStatus;
    })
  }

  cambiarFiltro(status) {
    this.defaultStatus = status;
    if(this.lastStatus == this.defaultStatus){return;}
    this.consultaCreditos();
  }

  async altaPersonales(){
    console.log(this.datosEmpleado)
    if(this.datosEmpleado['customer_id']){
      console.log('Hay customer_id, formato alta personales porque es GPA');
    }else if(this.datosEmpleado['gov_customer_id']){
      if(this.datosEmpleado['business_name'].toLowerCase().includes('finanzas')){
        console.log('Es un cliente de finanzas, formato alta personales LEASING SAF');
      }else{
        console.log('NO es un cliente de finanzas, formato alta personales LEASING SSY');
      }
    }
    this.creditosService.getCustomerRegistrationReport(this.datosEmpleado['customer_credit_id']).subscribe(async resp => {
      console.log(resp);
      /* const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Formato');

      // Aumentamos el alto de algunas filas
      sheet.getRow(2).height = 25;

      // === Encabezado principal ===
      sheet.mergeCells('B2', 'P2');
      const header = sheet.getCell('B2');
      header.value = 'FORMATO - ALTA PERSONALES';
      header.font = { bold: true, size: 16 };
      header.alignment = { horizontal: 'center' };

      // === Datos del cliente ===
      const campos = [
        { celda: 'B6', etiqueta: 'NOMBRE DEL CLIENTE' },
        { celda: 'B8', etiqueta: 'RFC' },
        { celda: 'B10', etiqueta: 'CURP' },
        { celda: 'B12', etiqueta: 'FECHA DE OPERACIÓN' },
        { celda: 'H12', etiqueta: 'FECHA AUTORIZACIÓN' },
        { celda: 'B14', etiqueta: 'MONTO SOLICITADO' },
        { celda: 'H14', etiqueta: 'TIPO DE CRÉDITO' },
        { celda: 'L14', etiqueta: 'PLAZO' },
      ];

      campos.forEach(campo => {
        const cell = sheet.getCell(campo.celda);
        cell.value = campo.etiqueta;
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'left' };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFDCE6F1' } // azul clarito
        };
        // Agregar celda contigua para escribir datos
        const col = ExcelJS.Workbook.xlsx.utils?.decode_col(campo.celda[0]) || campo.celda[0];
        sheet.getCell(`${campo.celda[0]}${parseInt(campo.celda.slice(1)) + 1}`).border = {
          bottom: { style: 'thin' }
        };
      });

      // Opcional: ajustar ancho de columnas A–P
      for (let i = 1; i <= 16; i++) {
        sheet.getColumn(i).width = 20;
      }

      // Guardar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(new Blob([buffer]), 'Formato_Seccion1.xlsx'); */
    })
  }

  mostrarMensajeRechazo(row: any) {
    console.log(row)
  swal2.fire({
    title: 'Motivo',
    text: row['customer_credit'].rejection_note || 'No hay motivo registrado.',
    icon: 'info',
    confirmButtonText: 'OK'
  });
}

  cargar(length){
    if(length == this.creditos.length){
      this.cargado = true
    }
  }

  dragEnter(id: string) {
      document.getElementById(id).style.border = "dashed 3px #73CB38";
    }
  dragLeave(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }
  drop(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }
  
  async fileBrowseHandler( event: any, doc: string, credito ) {
      const file: File = event.target.files[0];

      const imgExtensiones = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml'
      ];

      if(doc == 'firma'){
        if (file && !imgExtensiones.includes(file.type)) {
          swal2.fire('Atención', 'Solo se permiten imágenes (PNG, JPG, JPEG, etc.)', 'info');
          event.target.value = '';
          return;
        }
      }

      if(doc == 'firmado'){
        if (file && file.type !== 'application/pdf') {
          swal2.fire('Atención', 'Solo se permiten archivos PDF', 'info');
          event.target.value = ''; // Limpia el input
          return;
        }
      }

      await this.callupload(file, doc, credito);
    }
  
  async fileDelete( doc: string, credito ) {

      swal2.fire({
        title: 'Eliminar',
        text: '¿Desea eliminar el documento?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(result => {
        if (result.isConfirmed) {
          swal2.fire({
            title: 'Eliminando...',
            didOpen: () => swal2.showLoading(),
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false
          });

          this.calldelete(doc, credito);

        } else {
          // window.location.reload();
        }
      });
    }
  
  async updateStatus( doc: string, credito ) {

      swal2.fire({
        title: 'Regresar estatus',
        text: '¿Desea modificar el estatus del credito?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, modificar',
        cancelButtonText: 'No',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(result => {
        if (result.isConfirmed) {
          swal2.fire({
            title: 'Selecciona el nuevo estatus',
            input: 'select',
            inputOptions: {
                'PA': 'Pendiente Aprobacion'
                // 'AC': 'Aceptado',
                // 'PR': 'Propuesto'
            },
            inputPlaceholder: 'Ingresa el nuevo estatus...',
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return 'Debes ingresar un estatus';
              }
            },
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
          }).then((res) => {
          if (res.isConfirmed) {
              const status = res.value;
              let update: any = {};
              update['status'] = status;
              swal2.fire('Cargando...');
              swal2.showLoading();
              this.updateCredit(credito.customer_credit_id, update);
            }
         });

        } else {
          window.location.reload();
        }
      });
    }
    
      
  async callupload(file, doc, credito) {
    var selectedCredit = this.creditos.findIndex(c => c.customer_credit_id == credito['customer_credit_id']);
    try {
      const r = await this.awsService.uploadFileSB(file, credito['customer_credit_id']);
      var param = {};
      if(doc == 'firmado'){
        param = {attached: r['url']}
      }else if(doc == 'firma'){
        param = {photography: r['url']}
      }
      (await this.creditosService.updateCredit(credito['customer_credit_id'], param)).toPromise().then(resp => {
        if(doc == 'firmado'){
          this.datosEmpleado['attached']= r['url']
          this.creditos[selectedCredit]['attached'] = r['url'];
        }else if(doc == 'firma'){
          this.datosEmpleado['photography']= r['url']
          this.creditos[selectedCredit]['photography'] = r['url'];
        }
      });
    } catch (error) {
      console.log('error', error);
      let resp = {
        status: false,
        resp: error,
        msg: 'Fallo al subir archivo'
      }
      try{
        swal2.fire(error.error.error, error.error.exception, 'info');
      }catch{
        swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
      }
      return resp
    }
  }

  async calldelete(doc,credito){
    var selectedCredit = this.creditos.findIndex(c => c.customer_credit_id == credito['customer_credit_id']);
    try {
      var param = {};
        if(doc == 'firmado'){
          param = {attached: ''}
        }else if(doc == 'firma'){
          param = {photography: ''}
        }
        
      await this.creditosService.updateCredit(credito['customer_credit_id'], param).toPromise().then(resp => {
            if(doc == 'firmado'){
              this.datosEmpleado['attached']= ''
              this.creditos[selectedCredit]['attached'] = ''
            }else if(doc == 'firma'){
              this.datosEmpleado['photography']= ''
              this.creditos[selectedCredit]['photography'] = ''
            }
            swal2.close();
            setTimeout(() => {
              swal2.fire('Éxito', 'Documento eliminado', 'success').then(() => {
              });
            }, 200);
        });
    } catch (error) {
      console.log('error', error);
      let resp = {
        status: false,
        resp: error,
        msg: 'Fallo al borrar archivo'
      }
      try{
        swal2.fire(error.error.error, error.error.exception, 'info');
      }catch{
        swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
      }
      return resp
    }
  }

  excelSiac(){
    var creditos = [];
    var generales = [];
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let start_date;

    if(month < 10){
      start_date =  `${day}0${month}${year}`;
    }else{
      start_date = `${day}${month}${year}`;
    }
    this.creditos.filter(c => c.cat2 == '' || c.cat2 == null || c.siac_id == '' || c.siac_id == null).forEach(item => {
      var base = {
        'No. De Control': item.credit_folio || '',
        'Nombre ': item.nombre || '',
        'Monto': item.cpago_fijo || '',
        'Tasa': item.rate || '',
        'Plazo ': item.plazo || '',
      };
      creditos.push(base);

      var generals = {
        'Apellido Paterno': item.apellido_paterno || '',
        'Apellido Materno': item.apellido_materno || '',
        'Nombres': item.nombres || '',
        'Dirección (Calle)': item.calle || '',
        'No. Exterior' : item.no_exterior || '',
        'No. Interior' : item.no_interior|| '',
        'C.P.' : item.cp || '',
        'Municipio' : item.municipio || '',
        'Colonia' : item.colonia || '',
        'Entidad Federativa de nacimiento' : item.entidad_federativa_nacimiento || '',
        'Fecha de nacimiento' : item.fecha_nacimiento || '',
        'RFC' : item.rfc || '',
        'CURP' : item.curp || '',
        'Estado Civil' : this.estadoCivil(item.estado_civil) || '',
        'TIPO ID' : item.tipo_id || '',
        'Folio ID ' : item.folio_id || '',
      }

      generales.push(generals);
    })
    
    const readOpts = {
      cellText: false, 
      cellDates: true,
    };
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(creditos, readOpts);
    const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(generales, readOpts);
    const wb: XLSX.WorkBook = XLSX.utils.book_new(); 
    XLSX.utils.book_append_sheet(wb, ws2, 'Datos generales');
    XLSX.utils.book_append_sheet(wb, ws, 'Creditos');
    XLSX.writeFile(wb, `SIAC_${start_date}.xlsx`, readOpts);
  }

  estadoCivil(estado){
    if(estado == 'SO'){
      return 'Soltero';
    }else if(estado == 'CA'){
      return 'Casado';
    }
  }

  consultaRefinanciamiento(id){
    this.creditosService.getFinDetailsbycustomerCredit(id).subscribe(resp => {
      console.log('el refinanciamiento', resp)
      this.refinanciamientoItems = JSON.parse(JSON.stringify(resp));
      this.refinanciamientoItems.forEach(r => {
        r['financiera'] = this.companies.find(c => c.id == r.company_id).business_name;
      })
    })
  }

  async detalleCliente(rowData, show=true, callbacks?: {onComplete?: Function, onError?: Function}) {
    swal2.showLoading();
    this.credit = rowData;
    this.reportesService.getRegistrationInfo(this.credit.credit_uuid).subscribe((info: any) => {
      const datos = info[0];
      this.credit['destino'] = datos.extra3 || 'Inversion';
      this.credit['customer_id'] = datos.customer_id;
      this.credit['gov_customer_id'] = datos.gov_customer_id;

      this.creditosService.getCredit(this.credit.credit_uuid).subscribe((customer_credit: any) => {
        this.credit['customer_credit'] = customer_credit.data.attributes;
        if(this.credit['customer_credit']['refinancing']){
          this.consultaRefinanciamiento(this.credit['customer_credit']['id']);
        }
        

        this.creditosService.traer_customer(customer_credit.data.attributes.id).subscribe((customer: any) => {
          const cus = customer[0];

          this.credit.created_at = customer_credit.data.attributes.created_at;
          this.credit['comision'] = customer_credit.data.attributes.commission1;
          this.credit['seguro'] = customer_credit.data.attributes.insurance1;
          this.credit.customer = cus;
          this.credit['nombre'] = this.credit?.customer?.nombre + ' ' + this.credit?.customer?.apellido_paterno + ' ' + this.credit?.customer?.apellido_materno;
          this.credit['attached'] = customer_credit.data.attributes.attached;
          this.credit['customer_credit_id'] = customer_credit.data.attributes.id;
          this.credit['photography'] = customer_credit.data.attributes.photography;
          this.credit['credit_number'] = customer_credit.data.attributes.credit_number;
          this.credit['cat'] = customer_credit.data.attributes.destination;
          this.credit['cat2'] = customer_credit.data.attributes.destination;

          this.showmodalds = show;
          this.cartasRevisadas = new Set();
          this.datosEmpleado = {};
          this.egresos_netos = this.credit?.customer?.egresos_netos;
          if (!this.credit?.customer?.gastos_familiares){
            this.gastos_familiares = this.formatNumber(this.esNulo(parseFloat('2500').toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
            this.gastos_familiaresnum = parseFloat('2500');
          } else if(this.credit?.customer?.gastos_familiares == 0 ) {
            this.gastos_familiares = this.formatNumber(this.esNulo(parseFloat(this.credit?.customer?.gastos_familiares).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2})) + 2500;
            this.gastos_familiaresnum = parseFloat(this.credit?.customer?.gastos_familiares) + 2500;
        } else{
          this.gastos_familiares = this.formatNumber(this.esNulo(parseFloat(this.credit?.customer?.gastos_familiares).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          this.gastos_familiaresnum = parseFloat(this.credit?.customer?.gastos_familiares)
        }
        
        this.renta_casa = this.formatNumber(this.esNulo(parseFloat(this.credit?.customer?.renta).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
        this.creditos_CP = this.formatNumber(this.esNulo(parseFloat(this.credit?.customer?.creditos_cp).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
        
        this.renta_casanum = parseFloat(this.credit?.customer?.renta)
        this.creditos_CPnum = parseFloat(this.credit?.customer?.creditos_cp)
        this.creditos_LPnum = parseFloat(this.credit?.customer?.creditos_lp)
          this.periodo_pago = this.formatNumber(this.esNulo(parseFloat(this.credit?.customer?.periodo_pago).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
          // this.datosdetalles = [];
          // this.datosdetalles.push(this.credit?.customer?);
          
          var observableAnalysis = this.creditosService.tiene_analisis(this.credit?.customer);
          var observableBuro = this.creditosService.tiene_buro(this.credit?.customer);
          var observableInfo = this.reportesService.getRegistrationInfo(this.credit?.customer?.id_credito)
          forkJoin([observableAnalysis, observableBuro, observableInfo]).subscribe(([analysis, buro, info]) => {
          
          // this.creditosService.tiene_analisis(this.credit?.customer).subscribe(analysis => {
            this.analysisStatus = analysis.status;
            if (this.analysisStatus){
              this.analysis = analysis.credit_analysis;
              this.accured_liabilities = this.analysis[0]['accured_liabilities']
              this.debt_horizon = this.analysis[0]['debt_horizon']
              this.anual_rate = this.analysis[0]['anual_rate'];
              this.balance_due = this.analysis[0]['balance_due'];
              this.car_credit = this.analysis[0]['car_credit'];
              this.car_creditnum = parseFloat(this.analysis[0]['car_credit']);
              this.credit_status = this.analysis[0]['credit_status'];
              this.credit_status1 = this.analysis[0]['credit_status'];
              this.cash_flow = this.analysis[0]['cash_flow'];
              if(parseFloat(this.cash_flow) >= 80 && parseFloat(this.cash_flow) <= 100 ){
                this.estatusflow = "check"
              }else if(parseFloat(this.cash_flow) >= 101 && parseFloat(this.cash_flow) <= 110){
                this.estatusflow = "priority_high"
              }else{
                this.estatusflow = "close"
              }
              this.created_at = this.analysis[0]['created_at'];
              this.analisis_credit_status = this.analysis[0]['credit_status'];
              this.credit_type = this.analysis[0]['credit_type'];
              this.customer_credit_id = this.analysis[0]['customer_credit_id'];
              this.customer_number = this.analysis[0]['customer_number'];
              this.debt = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['debt']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
              this.debtnum = parseFloat(this.analysis[0]['debt'])
              this.debt_rate = this.analysis[0]['debt_rate'];
              if(parseFloat(this.debt_rate) <= 49){
                this.estatusindice = "check"
              }else if(parseFloat(this.debt_rate) >= 50 && parseFloat(this.debt_rate) <= 65){
                this.estatusindice = "priority_high"
              }else{
                this.estatusindice = "close"
              }
              this.departamental_credit = this.analysis[0]['departamental_credit'];
              // this.discounts = this.analysis[0]['discounts'];
              // var discountsn =  parseInt(this.analysis[0]['discounts']).toFixed(2);
              this.discounts =  (parseInt(this.analysis[0]['discounts']).toFixed(2)).toString() + "%";
              // this.discounts =  discountsn.toString() + "%";
              this.id = this.analysis[0]['id'];
              this.last_key = this.analysis[0]['last_key'];
              this.lowest_key = this.analysis[0]['lowest_key'];
              this.mop_key = this.analysis[0]['mop_key'];
              this.mortagage_loan = this.analysis[0]['mortagage_loan'];
              this.mortagage_loannum = parseFloat(this.analysis[0]['mortagage_loan'])
              this.net_flow = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['net_flow']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
              this.net_flownum = parseFloat(this.analysis[0]['net_flow'])
              this.other_credits = this.analysis[0]['other_credits'];
              this.overall_rate = this.analysis[0]['overall_rate'];
              this.payment_capacity = this.analysis[0]['payment_capacity'];
              if(parseFloat(this.payment_capacity) <= 50){
                this.estatuspayment = "check"
              }else if(parseFloat(this.payment_capacity) >= 51 && parseFloat(this.payment_capacity) >= 65){
                this.estatuspayment = "priority_high"
              }else{
                this.estatuspayment = "close"
      
              }
              this.previus_credit = this.analysis[0]['previus_credit'];
              this.report_date = this.analysis[0]['report_date'];
              this.total_amount = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['total_amount']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
              this.total_cost = this.analysis[0]['total_cost'];
              this.total_debt = this.analysis[0]['total_debt'];
              this.egresos_netos = this.formatNumber(this.esNulo(parseFloat(this.analysis[0]['monthly_expenses']).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
              this.egresos_netosnum = parseFloat(this.analysis[0]['monthly_expenses'])
              this.creditos_LPnum = this.creditos_LPnum + this.mortagage_loannum + this.car_creditnum
              if(parseFloat(this.discounts) > 30){
                this.estatus1 = "close"
              }else{
                this.estatus1 = "check"
              }
              this.creditos_LP = this.formatNumber(this.esNulo(this.creditos_LPnum.toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
            }else {
              console.log("NO TIENE ANALISIS")
            }
      
          // })
      
          // this.creditosService.tiene_buro(this.credit?.customer).subscribe(buro => {
            this.buroStatus = buro.status;
            if (this.buroStatus){
              this.buro = buro.credit_bureau;
              if(!this.buro['bureau_info']){
                this.fechaReporte = this.buro['bureau_report']['respuesta']['persona']['hawkAlertConsulta'][0]['fechaReporte'];
                this.rfcBC = this.buro['bureau_report']['respuesta']['persona']['nombre']['rfc'];
                this.saldosVencidos = this.buro['bureau_report']['respuesta']['persona']['resumenReporte'][0]['totalSaldosVencidosPagosFijos']
                this.calificacionBC = this.buro['bureau_report']['respuesta']['persona']['scoreBuroCredito'][0]['valorScore']
                this.resumen_creditos = this.buro['bureau_report']['respuesta']['persona']['cuentas']
              }else{
                this.fechaReporte = this.buro['bureau_report']['results'][0]['updatedAt'];
                this.rfcBC = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['Nombre']['RFC'];
                this.saldosVencidos = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['ResumenReporte']['ResumenReporte'][0]['TotalSaldosVencidosPagosFijos']
                this.calificacionBC = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['ScoreBuroCredito']['ScoreBC'][0]['ValorScore']
                this.resumen_creditos = this.buro['bureau_report']['results'][1]['response']['return']['Personas']['Persona'][0]['Cuentas']['Cuenta']
              }
      
              this.pdf = this.buro['extra1']
              this.urlburo = `https://docs.google.com/viewer?url=${this.pdf}&embedded=true`
      
              if(this.calificacionBC <= 550){
                this.estatusburo = 'close'
                // this.estatusburo = 'priority_high'
              }else if(this.calificacionBC >= 551 && this.calificacionBC <=650){
                this.estatusburo = 'priority_high'
              }else{
                this.estatusburo = 'check'
              }
              this.creditos_buro = this.get_ur_credits(this.resumen_creditos)
            }else {
              // console.log("NO TIENE BURO")
            }
          // })
          
          // this.reportesService.getRegistrationInfo(this.credit?.customer?.id_credito).subscribe(info => {
            this.datosEmpleado = info[0];
            this.datosEmpleado['customer_credit'] = rowData['customer_credit']
            this.datosEmpleado['customer_id'] = rowData['customer_id']
            this.datosEmpleado['gov_customer_id'] = rowData['gov_customer_id']
            this.datosEmpleado['attached'] = rowData['attached']
            this.datosEmpleado['photography'] = rowData['photography']
            this.datosEmpleado['customer_credit_id'] = rowData['customer_credit_id']
            this.datosEmpleado['dependientes'] = parseInt(this.datosEmpleado['senior_dependents']) + parseInt(this.datosEmpleado['minior_dependents'])
            this.datosEmpleado['martial_status_value'] = this.maritalStatus.find(m => m.key == this.datosEmpleado['martial_status']).value;
            this.datosEmpleado['fiscal_regime_value'] = this.regimen_fiscal.find(r => r.key == this.datosEmpleado['fiscal_regime']).value;
            this.datosEmpleado['business_name'] = this.credit?.customer?.business_name;
            if(this.datosEmpleado['salary_period'] == 'QUINCENAL'){
              this.datosEmpleado['month_salary'] = ( parseFloat(this.datosEmpleado['salary']) + parseFloat(this.esNulo(this.datosEmpleado['ontime_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['assist_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['food_vouchers']))) * 2;
            }else if(this.datosEmpleado['salary_period'] == 'SEMANAL'){
              this.datosEmpleado['month_salary'] = (parseFloat(this.datosEmpleado['salary'])  + parseFloat(this.esNulo(this.datosEmpleado['ontime_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['assist_bonus'])) +  parseFloat(this.esNulo(this.datosEmpleado['food_vouchers']))) * (4.33);
            }
            let ingresos_mensuales_y_otros_ingresos = parseFloat(this.datosEmpleado['month_salary']) + parseFloat(this.datosEmpleado['other_income']);
            this.ingresos_netos = this.formatNumber(this.esNulo(ingresos_mensuales_y_otros_ingresos.toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
            this.ingresos_netosnum = ingresos_mensuales_y_otros_ingresos;
            // this.ingresos_netos = ( parseInt(this.esNulo(this.datosEmpleado['month_salary'])) + parseInt(this.esNulo(this.datosEmpleado['ontime_bonus'])) +  parseInt(this.esNulo(this.datosEmpleado['assist_bonus'])) +  parseInt(this.esNulo(this.datosEmpleado['food_vouchers'])) );
            this.awsService.getUserDocuments(this.credit?.customer?.id_contribuyente).subscribe(docs => {
              this.documents = [];
              docs['data'].forEach(doc => {
                if(doc.attributes.name == "Comprobantes de ingresos del empleado"){
                  var arrayUrl = doc.attributes.url.split('*');
                  arrayUrl.forEach(url => {
                    if(url != ''){
                      let params = {
                        contributor_id: doc.attributes.contributor_id,
                        created_at: doc.attributes.created_at,
                        extra1: null,
                        extra2: null,
                        extra3: null,
                        file_type_document_id: doc.attributes.file_type_document_id,
                        id: doc.attributes.id,
                        name: doc.attributes.name,
                        notes: null,
                        status: doc.attributes.status,
                        updated_at: doc.attributes.updated_at,
                        url: url
                      }
                      let variable = doc.attributes;
                      variable.url = url;
                      this.documents.push(params);
                    }
                  });
                }else{
                  this.documents.push(doc.attributes);
                }
              });
              if(this.buroStatus){
                if(this.buro['extra1'] != null){
                  this.documents.push({'url': this.buro['extra1'], 'name': 'Reporte Buró de Crédito'});
                }
              }
              this.datosEmpleado['customer_credit']['payment_capacity_percentage'] = ((parseFloat(this.datosEmpleado['extra_expenses']) + parseFloat(this.datosEmpleado['expenses'])) * 100) / (parseFloat(this.datosEmpleado['salary']) + parseFloat(this.datosEmpleado['extra_income']));
              this.datosEmpleado['customer_credit']['payment_capacitym'] = (parseFloat(this.datosEmpleado['salary']) + parseFloat(this.datosEmpleado['extra_income'])) * 0.3;
              this.datosEmpleado['customer_credit']['term'] = this.terms.find(t => t.id == this.datosEmpleado['customer_credit']['term_id']).key;
              if(this.datosEmpleado['reporte_final'] !== null && this.datosEmpleado['reporte_final'] !== undefined && this.datosEmpleado['reporte_final'] != ''){
                this.documents.push({'url': this.datosEmpleado['reporte_final'], 'name': 'Expediente firmado'});
              }else if(this.datosEmpleado['extra1'] !== null && this.datosEmpleado['extra1'] !== undefined && this.datosEmpleado['extra1'] !== ''){
                this.documents.push({'url': this.datosEmpleado['extra1'], 'name': 'Expediente'});
              }else if(this.datosEmpleado['gov_customer_id'] && this.datosEmpleado['gov_customer_id'] != null && this.datosEmpleado['fotografia'] !== null && this.datosEmpleado['fotografia'] !== undefined && this.datosEmpleado['fotografia'] !== ''){
                this.documents.push({'url': this.datosEmpleado['fotografia'], 'name': 'Evidencia firma'});
              }    
            })
          if(callbacks?.onComplete) callbacks.onComplete();
          });

          swal2.close();

        });
      });
    });

  }

  hideds() {
    if (!this.validarCartasRefinanciamiento()) return;
    this.showmodalds = false;
    // window.location.reload();
  }

  marcarCartaRevisada(itemId: string) {
    this.cartasRevisadas.add(itemId);
  }

  onStepChange(event, stepper) {
    // Si se sale del step "Datos de Crédito" (índice 1), validar cartas
    if (event.previouslySelectedIndex === 1 && !this.validarCartasRefinanciamiento()) {
      setTimeout(() => { stepper.selectedIndex = 1; });
    }
  }

  validarCartasRefinanciamiento(): boolean {
    // Solo aplica para el rol de Mesa de control
    if (!this.mesaControl) {
      return true;
    }
    if (this.credit?.customer_credit?.refinancing && this.refinanciamientoItems.length > 0) {
      // Si ya fue revisado previamente, no bloquear
      if (this.credit?.customer_credit?.refinancing_reviewed) {
        return true;
      }
      const cartasConAttached = this.refinanciamientoItems.filter(i => i['attached']);
      if (cartasConAttached.length > 0 && this.cartasRevisadas.size < cartasConAttached.length) {
        swal2.fire('Atención', 'Debe revisar todas las cartas de refinanciamiento antes de continuar', 'info');
        return false;
      }
      // Si todas revisadas y no se ha marcado aún, hacer PATCH
      if (cartasConAttached.length > 0 && this.cartasRevisadas.size >= cartasConAttached.length) {
        this.creditosService.updateCredit(this.credit.credit_uuid, { refinancing_reviewed: true, refinancing_reviewed_by: this.idu }).subscribe(resp => {
          console.log('Refinanciamiento marcado como revisado');
          this.credit['customer_credit']['refinancing_reviewed'] = true;
          var idx = this.creditos.findIndex(c => c.credit_uuid === this.credit.credit_uuid);
          if (idx > -1) { this.creditos[idx].refinancing_reviewed = true; }
        });
      }
    }
    return true;
  }

  esNulo (dato){
    if(dato == null){
      return 0;
    }else{
      return dato;
    }
  }

  showModalf(rowData) {
    var id = rowData.credit_uuid;
    this.creditosService.getCredit(id).subscribe(resp => {
      this.creditoSeleccionadoTabla = resp['data'].attributes;
      this.payments = [];
      this.creditosService.customerCreditPayments(id).subscribe(pays => {
        pays['data'].forEach(p => {
  /*         this.payments.push(p['attributes']); */
          const payment = p['attributes'];/* borrar */
          if(payment.commission == null ){
            payment.commission = 0
          }
          if(payment.insurance == null ){
            payment.insurance = 0
          }
  /*         payment.insurance = 100; // Valor fijo de seguro
          payment.commission = 50; // Valor fijo de comisión */
          this.payments.push(payment);/* borrar */
        });
      });
      
      this.showModal = true; // Show-Hide Modal Check
    })
  }

  hideModal() {
    this.showModal = false;
  }  

  
  formatNumber(n) {
    // format number 1000000 to 1,234,567
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  guardar(){
    let usuario = (document.getElementById('usuario') as HTMLInputElement).value;
    let estatus = (document.getElementById('estatus') as HTMLInputElement).value;
    if (usuario === '0' && estatus === '0') {
      swal2.fire('Alerta', 'Debe seleccionar un usuario o estatus a asignar', 'info');
    return;
    }
    /* if (this.selectedSol.length !== 1) {
        swal2.fire('Alerta', 'Debe seleccionar un único crédito', 'info');
        return;
    } */
   if(this.selectedSol.length > 1 && !this.tesoreria){
    swal2.fire('Alerta', 'Debe seleccionar solo un crédito', 'info');
    return;
   }
   this.selectedSol.forEach( sel => {
    const credito = sel;
    // Validar refinanciamiento revisado (solo si se cambia estatus)
    if (estatus !== '0' && credito.refinancing && !credito.refinancing_reviewed) {
      swal2.fire('Atención', `El crédito ${credito.credit_folio} tiene refinanciamiento pendiente de revisión. Debe abrir las cartas antes de cambiar el estatus.`, 'info');
      return;
    }
    if (estatus === 'IN' && (!credito.gov_customer_id || credito.gov_customer_id === '')) {
      swal2.fire('Alerta', 'Este crédito no puede estar en estatus incompleto', 'info');
      return;
    }
    let update = {};
    if (estatus === 'IN' && credito.gov_customer_id) {

      swal2.fire({
      title: 'Captura el motivo',
      input: 'textarea',
      inputLabel: 'Motivo',
      inputPlaceholder: 'Describe el motivo del rechazo...',
      inputValidator: (value) => {
        if (!value || value.trim().length === 0) {
          return 'Debes ingresar un motivo';
        }
        return null;
      },
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          const motivo = result.value;
          let update: any = {};
          update['customer_credit'] = credito;
          if (usuario !== '0') {
            update['customer_credit']['user_id'] = usuario;
          }
          if (String(estatus) !== '0') {
            update['customer_credit']['status'] = estatus;
          }
          update['customer_credit']['rejection_note'] = motivo;
          swal2.fire('Cargando...');
          swal2.showLoading();
          this.updateCredit(credito.credit_uuid, update, false);
        }
      });
    } else {
      update['customer_credit'] = credito;
      if(usuario != '0'){
        update['customer_credit']['user_id'] = usuario;
      }
      if(String(estatus) !== '0'){
        update['customer_credit']['status'] = estatus;
        update['customer_credit']['rejection_note'] = null;
      }
      swal2.fire('Cargando...');
      swal2.showLoading();
      this.updateCredit(credito.credit_uuid, update, false);
    }

    swal2.fire({
      title: 'Éxito',
      text: 'Créditos actualizados correctamente',
      icon: 'success',
      showConfirmButton: true
    }).then(res => {
      if(res.value){
        window.location.reload();
      }
    })
   });
  }

  cleanURL(oldURL: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }

  updateCredit(uuid, update, actualizar = true){
    this.creditosService.updateCredit(uuid, update).subscribe(resp => {
      if(actualizar){
        swal2.fire({
          title: 'Éxito',
          text: 'Crédito actualizado correctamente',
          icon: 'success',
          showConfirmButton: true
        }).then(res => {
          if(res.value){
            window.location.reload();
          }
        })
      }
    }, err => {
      console.log('error', err);
      try{
        swal2.fire('Alerta', err.error.errors[0], 'info');
      }catch{
        swal2.fire('Alerta', 'Ha ocurrido un error', 'info');
      }
    })
  }

updateCreditCat(uuid, update, customer_credit_id, gov_customer_id, fiel_sign){
  swal2.fire({
    title: 'Cargando...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: false,
    showConfirmButton: false,
    didOpen: () => {
      swal2.showLoading();
    }
  });
  this.creditosService.updateCredit(uuid, update).subscribe(
    resp => {
      console.log('Resp actualizando crédito', resp);
      swal2.close();
      if (gov_customer_id && fiel_sign === 'SIMPLE') {
        swal2.fire({
          title: 'Crédito actualizado correctamente',
          text: '¿Desea solicitar la firma de MIFIEL de este documento?',
          icon: 'success',
          showCancelButton: true,
          confirmButtonText: 'Sí, solicitar firma',
          cancelButtonText: 'No',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(result => {
          if (result.isConfirmed) {
            swal2.fire({
              title: 'Solicitando firma...',
              didOpen: () => swal2.showLoading(),
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false
            });

            this.creditosService.solicitarFirma(customer_credit_id).subscribe(
              firmaResp => {
                console.log(firmaResp);
                swal2.close();
                setTimeout(() => {
                  swal2.fire('Éxito', 'Firma solicitada correctamente', 'success').then(() => {
                    window.location.reload();
                  });
                }, 200);
              },
              err => {
                swal2.close();
                setTimeout(() => {
                  console.error('Error solicitando firma', err);
                  let msg = 'Ha ocurrido un error al solicitar la firma';
                  if (err?.error?.errors && err.error.errors[0]) {
                    msg = err.error.errors[0];
                  }
                  swal2.fire('Alerta', msg, 'info').then(() => {
                    window.location.reload();
                  });
                }, 200);
              }
            );

          } else {
            window.location.reload();
          }
        });

      } else {
        swal2.fire('Éxito', 'Crédito actualizado correctamente', 'success').then(() => {
          window.location.reload();
        });
      }

    },
    err => {
      console.error('Error actualizando crédito', err);
      let msg = 'Ha ocurrido un error';
      if (err?.error?.errors && err.error.errors[0]) {
        msg = err.error.errors[0];
      }
      swal2.fire('Alerta', msg, 'info').then(() => {
        window.location.reload();
      });
    }
  );
}

  async keyFolio(e, rowData){
    const { value: cat } = await Swal.fire({
      title: "Teclea el CAT del crédito",
      input: "text",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Debes capturar el valor del CAT";
        }
      }
    });
    if (cat) {
      rowData['destination'] = cat;
      this.contribuyenteService.updateContributor(rowData.contributor_id, {siac_id: e.target.value}).subscribe(resp => {
        this.actualizaCat(rowData);
      }, err => {
        swal2.fire('Atención', 'Ocurrió un error al actualizar el SIAC ID del contribuyente', 'info');
      });
    }
    /* if(e.keyCode == 13 && rowData.destination != null && rowData.destination != ''){  
    } */
  }

  detalleClienteAsync(rowData, flag): Promise<void> {
    return new Promise((resolve, reject) => {
      this.detalleCliente(rowData, flag, {
        onComplete: resolve,
        onError: reject
      });
    });
  }

  async actualizaCat(rowData){
    // this.detalleCliente(rowData, false).then(() => {
    await this.detalleClienteAsync(rowData, false);
    if(this.credit?.customer_credit && this.credit?.customer_credit?.gov_customer_id){
      var startDate = this.credit?.customer_credit?.start_date || '';
      console.log('yucatan');

      this.zone.runOutsideAngular(async () => {
        const { value: fecha } = await Swal.fire({
          title: "Selecciona la fecha de inicio del crédito",
          html: `<input type="date" id="fechaPicker" class="swal2-input" value="${startDate}">`,
          showCancelButton: true,
          confirmButtonText: "Guardar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          allowEscapeKey: false,
          focusConfirm: false,
          preConfirm: () => {
            const input = document.getElementById("fechaPicker") as HTMLInputElement;
            return input?.value || startDate;
            }
        });

        if(fecha){
          const update = {
            start_date: fecha,
            customer_credit_id: this.credit['customer_credit']['id']
          };
          this.creditosService.updateDateCredit(update).subscribe(resp => {
            this.credit['cat'] = this.credit['cat2'];
            console.log('Actualizar fecha inicio crédito', this.credit);
            
            update['customer_credit'] = {};
            update['customer_credit']['destination'] = this.credit.destination;
             this.updateCreditCat(this.credit.credit_uuid, update, this.credit.customer_credit_id, this.credit.gov_customer_id, this.credit['customer']?.fiel_sign);
          }, err => {
            console.log('error', err);
            swal2.fire('Atención', 'Ocurrió un error al actualizar la fecha de inicio del crédito', 'info');
          })
      }
    })
  }else{
    console.log('gpa');
    let update = {};
    update['customer_credit'] = {};
    update['customer_credit']['credit_number'] = this.credit.credit_number;
    this.credit['cat'] = this.credit['cat2'];
    update['customer_credit']['destination'] = this.credit.destination;
    swal2.showLoading();
    this.updateCreditCat(this.credit.credit_uuid, update, this.credit.customer_credit_id, this.credit.gov_customer_id, this.credit['customer']?.fiel_sign);

  }
      
      /* Swal.fire({
        title: "Selecciona la fecha de inicio del crédito",
        html: `
          <input type="date" id="fechaPicker" class="swal2-input" value="${startDate}">
        `,
        showCancelButton: true,
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        allowEscapeKey: false,
        preConfirm: () => {
          const fecha = (document.getElementById("fechaPicker") as HTMLInputElement).value;
          return fecha;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          var fecha = result.value;
          if(result.value == ''){
            fecha = this.credit['customer_credit']['start_date'];
          }else{
            fecha = result.value;
          }
          var update = {
            start_date: fecha,
            customer_credit_id: this.credit['customer_credit']['id']
          };
          // this.creditosService.updateDateCredit(update).subscribe(resp => {
          //   console.log(resp);
          //   // this.actualizaCat(this.credit);
          // }, err => {
          //   console.log('error', err);
          //   swal2.fire('Atención', 'Ocurrió un error al actualizar la fecha de inicio del crédito', 'info');
          // })
        }
      }); */
  // })
  }

  get_ur_credits(credits){ 
    var ur_credits = {mop: 'UR', cuentas_abiertas: 0, limite_abiertas: 0, maximo_abiertas: 0, saldo_actual: 0,
                saldo_vencido: 0, pago_realizar: 0, cuentas_cerradas: 0, limite_cerradas: 0, maximo_cerradas: 0,
                saldo_cerradas: 0, monto_cerradas: 0}

    var credits_01 = {mop: '01',cuentas_abiertas: 0, limite_abiertas: 0, maximo_abiertas: 0, saldo_actual: 0, saldo_vencido: 0,
    pago_realizar: 0, cuentas_cerradas: 0, limite_cerradas: 0, maximo_cerradas: 0, saldo_cerradas: 0,
    monto_cerradas: 0}


    var all_credits = []


    credits.forEach(credit =>{
      if(credit['FechaCierreCuenta'] && credit['FormaPagoActual'] === 'UR'){
        ur_credits['cuentas_cerradas'] += 1
        ur_credits['limite_cerradas'] += parseInt(credit['LimiteCredito'] ? credit['LimiteCredito'] : 0)
        ur_credits['maximo_cerradas'] += parseInt(credit['CreditoMaximo'])
        ur_credits['saldo_cerradas'] += parseInt(credit['SaldoActual'])
        ur_credits['monto_cerradas'] += parseInt(credit['MontoPagar'])
      }else if (credit['FechaCierreCuenta'] && credit['FormaPagoActual'] === '01'){
        credits_01['cuentas_cerradas'] += 1
        credits_01['limite_cerradas'] += parseInt(credit['LimiteCredito'] ? credit['LimiteCredito'] : 0)
        credits_01['maximo_cerradas'] += parseInt(credit['CreditoMaximo'])
        credits_01['saldo_cerradas'] += parseInt(credit['SaldoActual'])
        credits_01['monto_cerradas'] += parseInt(credit['MontoPagar'])
      }else if (!credit['FechaCierreCuenta'] && credit['FormaPagoActual'] === 'UR'){
        ur_credits['cuentas_abiertas'] += 1
        ur_credits['limite_abiertas'] += parseInt(credit['LimiteCredito'] ? credit['LimiteCredito'] : 0)
        ur_credits['maximo_abiertas'] += parseInt(credit['CreditoMaximo'])
        ur_credits['saldo_actual'] += parseInt(credit['SaldoActual'])
        ur_credits['saldo_vencido'] += parseInt(credit['SaldoVencido'])
        ur_credits['pago_realizar'] += parseInt(credit['MontoPagar'])
      }else if (!credit['FechaCierreCuenta'] && credit['FormaPagoActual'] === '01'){
        credits_01['cuentas_abiertas'] += 1
        credits_01['limite_abiertas'] += parseInt(credit['LimiteCredito'] ? credit['LimiteCredito'] : 0)
        credits_01['maximo_abiertas'] += parseInt(credit['CreditoMaximo'])
        credits_01['saldo_actual'] += parseInt(credit['SaldoActual'])
        credits_01['saldo_vencido'] += parseInt(credit['SaldoVencido'])
        credits_01['pago_realizar'] += parseInt(credit['MontoPagar'])
      }
    });

    all_credits.push(ur_credits)
    all_credits.push(credits_01)

    return all_credits
  }

  exportexcel() {
    this.fileName = "Layout" + '.xlsx';
    const Excel = require('exceljs');
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('base');
    let titulo = ['PLANTILLA DE PAGOS PROGRAMADOS']
    worksheet.addRow(titulo);
    worksheet.mergeCells(1, 1, 1, 2);
    let pagos = ['No. De pagos', this.payments.length]
    worksheet.addRow(pagos);
    let header=['Fecha de pago', 'Capital'];
    worksheet.addRow(header);
    for (const prop in this.payments) {
      var datePipe = new DatePipe('en-US');
      var fecha = datePipe.transform(this.payments[prop].payment_date, 'dd/MM/yyyy');
      worksheet.addRow([
        // this.payments[prop].pay_number,
        // new Date(this.payments[prop].payment_date).toLocaleDateString('en-GB'),
        fecha,
        this.payments[prop].capital
      ]);
    } 
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: '.xlsx' });
      const file = blob;
      fs.saveAs(blob, this.fileName);
  });
  }

  get esFirmadoDigitalmente(): boolean {
    // console.log('disparo check')
  const texto = (this.datosEmpleado['photography'] || '').toLowerCase().replace(/\s+/g, ' ').trim();
  return texto.includes('firmado digitalmente por mifiel');
}

mostrarFirmadoDigitalmente() {
   swal2.fire('Ya fue firmado digitalmente');
}

}
